import { ForecastPromo } from '../components/surf-forecast/surf-forecast.component'
import React, { useRef } from 'react'
import { useRouter } from 'next/router'
import { getClient } from '../client'
import { groqListingsBySection } from '../lib/libFunctions'

// Styles
import { base } from '../styles/base/_allBase.styles'
const { GridItem_HeaderSection, GridContainer_Page_Layout, Page_Main_Grid_Container } = base

// Components
import SEO from '../components/seo-head/seo-head'
import SectionOne from '../components/section-one/section-one.jsx'
import { Header } from '../components/header/header'
import { Footer } from '../components/footer/footer.component.jsx'
import { SurfLessonPlanning } from '../components/surf-planning/surf-planning.component'
import { ListingGrid } from '../components/listing-grid/listing-grid.component'

const header = {
  header: 'Surf Schools in Selong Belanak',
  subheader:
    'Learn to surf or sharpen your skills with local surf schools and camps around Selong Belanak.',
}
const seo = {
  titleFormat: 'complete',
  metaTitle: 'Surf Schools & Lessons in Selong Belanak',
  metaDesc: 'Compare surf schools in Selong Belanak, Lombok. Find beginner lessons, board hire and local instructors, with school details to help plan your first session.',
}

export default function SurfHub({ listings }) {
  const sectionOneRef = useRef()
  const router = useRouter()
  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <SectionOne header={header} variant="directory" />
          <SurfLessonPlanning />
          <ListingGrid listings={listings} filterByCategory />
          <ForecastPromo placement="surf-schools" />
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export async function getServerSideProps() {
  const listings = await getClient().fetch(groqListingsBySection('Surf'))
  return { props: { listings } }
}
